<template>
  <div id="app">
    <router-view />
    <GlobalMessage />
  </div>
</template>

<script>
import GlobalMessage from "./components/global/GlobalMessage.vue";

export default {
  components: {
    GlobalMessage,
  },
};
</script>

<style>
:root {
  font-family: "Frutiger LT Arabic", Arial, sans-serif;
}
</style>
